import { Component, ViewChild } from '@angular/core';

import { CalendarComponent } from 'src/app/common/calendar.component';

import { DriversCalendarFiltersComponent } from './drivers-calendar-filters/drivers-calendar-filters.component';

@Component({
	selector: 'app-drivers-calendar',
	templateUrl: './drivers-calendar.component.html',
	styleUrls: ['./drivers-calendar.component.css'],
})
export class DriversCalendarComponent extends CalendarComponent {
	@ViewChild(DriversCalendarFiltersComponent)
	driversCalendarFiltersComponent: DriversCalendarFiltersComponent;
	private itemsBeforeDataLoad = 8;
	data: Array<Driver>;
	module = 'driversCalendar';
	allDrivers: Array<any> = [];
	vehicles: Array<any> = [];
	touristGuides: Array<any> = [];
	drivers: Array<Driver> = [];
	driverTypes: Array<any> = [];
	eventTypes: Array<any> = [];
	cities: Array<any> = [];
	users: Array<any> = [];
	statuses: Array<any> = [];
	driverKinds: Array<any> = [];
	parameters = {
		status: [],
		statuses: [],
		category: [],
		yesno: [],
		drivers: [],
		showDeleted: [],
		driverKinds: [],
	};
	filters = {
		showDeleted: 0,
	};
	selectedObject = {
		id: null,
		name: null,
	};

	protected loadAdditionalData(): void {
		this.api.get('/vehicles/', (result, error) => {
			this.vehicles = result.data;
		});
		this.api.get('/driverStatus/', (result, error) => {
			this.statuses = result.data;
			this.parameters.statuses = this.statuses;
		});
		this.api.get('/touristGuides/', (result, error) => {
			this.touristGuides = result.data;
		});
		this.api.get('/parameters/', (result, error) => {
			this.parameters.category = this.api.typeParametersConvert(result.data, 6);
			this.parameters.yesno = [
				{ id: 1, name: 'Tak' },
				{ id: 0, name: 'Nie' },
			];
			// this.parameters.status = this.api.typeParametersConvert(result.data, 7);
			this.loadData();
		});
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
		});
		this.api.get('/drivers/', (result, error) => {
			this.allDrivers = result.data;
			this.parameters.drivers = this.allDrivers;
		});
		this.api.get('/driverStatus/', (result, error) => {
			this.driverTypes = result.data;
			this.loadData();
		});
		this.api.get('/driversEventsTypes/', (result, error) => {
			this.eventTypes = result.data;
			this.loadData();
		});
		this.api.get('/nearestBigCity/', (result, error) => {
			this.cities = result.data;
			this.loadData();
		});
		this.api.get('/tourismEventsStatuses/', (result, error) => {
			this.parameters.status = result.data;
			this.loadData();
		});
		this.api.get('/driverKinds/', (result, error) => {
			this.driverKinds = result.data;
			this.loadData();
		});
	}

	protected loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		delete this.filters['date_from'];
		delete this.filters['date_to'];
		this.loader.show();
		const parms: string = this.api.getChecked(this.filters, this.parameters);
		this.api.get('/drivers/?' + parms, (result, error) => {
			this.drivers = this.parseDrivers(result.data);
			let parms = ''; //this.api.getChecked(this.filters);
			parms += '&date_from=' + this.date_from;
			parms += '&date_to=' + this.date_to;
			parms += '&showDeleted=' + this.filters.showDeleted;
			this.api.get('/tourismEvents/?' + parms, (result, error) => {
				this.parseDataToGridFormat(result.data);
				this.api.get('/driversEvents/?status=1&' + parms, (result, error) => {
					this.data = this.parseEventsToGridFormat(result.data);
					this.loader.hide();
				});
			});
		});
	}

	private parseDrivers(data) {
		const result: Array<Driver> = [];
		data.forEach((driver) => {
			const type = this.driverTypes.find((obj) => obj.id == driver.status);
			if (driver.nearest_city) {
				const city = this.cities.find((obj) => obj.id == driver.nearest_city);
				if (city) {
					driver.nearest_city = city.name;
				}
			}
			driver.comments = driver.comments ? driver.comments : '';
			result.push({
				id: driver.id,
				name: driver.last_name + ' ' + driver.first_name,
				events: [],
				checked: true,
				background: type?.background,
				order: type?.order,
				details: [
					{
						label: '',
						value: '<a href="/drivers/' + driver.id + '" target="_blank">Strona kierowcy</a>',
					},
					{
						label: 'Telefon',
						value: [driver.phone_business, driver.phone_private],
					},
					{
						label: 'E-mail',
						value: [driver.email_business, driver.email_private],
					},
					{
						label: 'Najbliższe miasto',
						value: driver.nearest_city,
					},
					{
						label: 'Szczepienia',
						value: driver.vaccinations,
					},
					{
						label: 'Przyczepka',
						value: driver.trailer,
					},
					{
						label: 'Ocena',
						value: driver.rate,
					},
					{
						label: 'Uwagi',
						value: '<pre>' + driver.comments + '</pre>',
					},
				],
			});
		});
		return result.sort((a, b) => a.name.localeCompare(b.name)).sort((a, b) => a.order - b.order);
	}

	private parseEventsToGridFormat(data) {
		let currentDriver: Driver;
		let driver: Driver;
		data.forEach((event) => {
			const type = this.eventTypes.find((obj) => obj.id == event.type);
			event.color = type ? '#' + type.color : '#999999';
			event.name = type ? type.name : '???';
			event.kind = 'driver';
			event.drivers.forEach((driverId) => {
				const driver = this.drivers.find((obj) => obj.id == driverId);
				if (!driver) {
					return;
				}
				let eventName = event.name;
				if (event.comments) {
					eventName += ' - ' + event.comments;
				}
				driver.events.push({
					id: event.id,
					name: eventName,
					date_from: event.date_from,
					date_to: event.date_to,
					background: event.color,
					kind: event.kind,
				});
			});
		});
		return this.drivers;
	}

	private parseDataToGridFormat(data) {
		data.forEach((event) => {
			event.kind = 'transport';
			event.color = '#ffaaaa';
			this.parseCrewsToGridFormat('departure', event);
			this.parseCrewsToGridFormat('program', event);
			this.parseCrewsToGridFormat('return', event);
		});
		return this.drivers;
	}

	private parseCrewsToGridFormat(type, event) {
		event['drivers_' + type].forEach((drivers) => {
			const driver = this.drivers.find((obj) => obj.id == drivers.driver);
			if (!driver) {
				return;
			}
			const date_from = !drivers.date_from ? event.date_from : drivers.date_from;
			const date_to = !drivers.date_to ? event.date_to : drivers.date_to;
			let eventName = '';
			switch (type) {
				case 'departure':
					eventName = '(D) ' + event.name;
					// if (event.program_date_from) {
					// 	date_to = event.program_date_from;
					// }
					break;
				case 'program':
					eventName = '(P) ' + event.name;
					// if (event.program_date_from) {
					// 	date_from = event.program_date_from;
					// }
					// if (event.program_date_to) {
					// 	date_to = event.program_date_to;
					// }
					break;
				case 'return':
					eventName = '(O) ' + event.name;
					// if (event.program_date_to) {
					// 	date_from = event.program_date_to;
					// }
					break;
			}
			driver.events.push({
				id: event.id,
				name: eventName,
				date_from: date_from,
				date_to: date_to,
				background: event.color,
				kind: event.kind,
			});
		});
	}

	eventOpen(event) {
		switch (event.element.kind) {
			case 'transport':
				this.selectedObject = {
					id: event.id,
					name: event.name,
				};
				break;
			case 'driver':
				this.router.navigate(['driver-event', event.id]);
				break;
		}
	}

	eventClosed(event) {}

	filtersOpen() {
		this.driversCalendarFiltersComponent.filtersOpen();
	}
}

class Driver {
	id: number;
	name: string;
	events: Array<Event>;
	checked: boolean;
	background: string;
	order: number;
	details: Array<any>;
}
class Event {
	id: number;
	kind: string;
	name: string;
	date_from: string;
	date_to: string;
	background: string;
}
